import { useHandbook, useHandbookKeys } from '~/controllers/handbook';

export function useGetlocalizedValue(value?: string, catKey?: any) {
  const handbook = useHandbook();
  const handbookKeys: any = useHandbookKeys();

  const localizedValue =
    handbook.data?.handbooks
      ?.find((item) => item.key === handbookKeys[catKey])
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ?.values?.find((item) => item.apiValue === value)?.localizedValue || value;

  return { localizedValue, isReady: !handbook?.isLoading };
}
